import { css } from '@emotion/css';

export const popperStyles = css`
  width: 24.8rem !important;
`;

export const autocompleteClasses = {
  popper: popperStyles,
};
